import React from 'react';
import Documentation from '../components/documentation/Documentation';

export const DocumentationPage: React.FC = () => {
  return <Documentation />;
};
